export const document = {
	label: {
		downloadEstimate: 'Download Estimate',
		downloadBlueprint: 'Download Blueprint'
	},
	tooltip: {
		generateEstimate: 'Click to generate an estimate for the current blueprint',
		generateBlueprint: 'Click to generate a blueprint for the current blueprint',
		missingCustomer: 'A customer must be loaded to use this feature. Use the "Find Customer" button in the toolbar to search by email or name.',
		missingHubspotData: 'This customer has no deals in HubSpot. Create a deal using the "Associated Deal" button in the HubSpot Options panel, or create one directly in HubSpot.'
	},
	message: {
		downloadEstimate: 'Estimate Downloaded!',
		downloadBlueprint: 'Blueprint Download Started!'
	}
};
